/**
 * 指定された配列から重複データを取り除く。
 * 同値性判定は[JavaScriptのSet](https://tc39.es/ecma262/multipage/keyed-collections.html#sec-set-objects)に基づく。
 *
 * @example
 * ```typescript
 * distinct([1, 1, 2, 3, 4, 3, 4]);
 * // => [1, 2, 3, 4]
 * ```
 * @param source 元データ
 * @returns 重複を取り除いた配列
 */
export const distinct = <T>(source: readonly T[]) => {
    const set = new Set<T>(source);
    return set.keys().toArray();
};

/**
 * 指定された配列から重複データを取り除く。
 *
 * @param source 元データ
 * @param valuePicker 同値とみなす基準となる値
 * @returns 重複を取り除いた配列
 */
export const distinctBy = <T, U>(source: readonly T[], valuePicker: (item: T) => U) => {
    const map = new Map<U, T>(source.map((x) => [valuePicker(x), x]));
    return map.values().toArray();
};
